import { createSlice } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import { AEstimateSliceState } from "../../utils/estimate.types";
import { ApiStatus } from "../../utils/api.types";
import { addEstimate, fetchEstimates, fetchEstimateById, updateEstimate,  dispatchSale, deleteEstimate } from "./estimateThunk";

/**
 * Estimate slice initial state.
 */
const initialState: AEstimateSliceState = {
    estimates: [],
    estimateDetails: {},
    errorMessage: '',
    isEstimateCreated: false,
    selectedEstimateId: '',
    status: ApiStatus.IDLE
}

/**
 * Invoice Slice.
 */
const estimateSlice = createSlice({
    name: 'invoice',
    initialState: initialState,
    reducers: {
        // Selected Estimate id
        //selectedInvoiceId: (state, action) => {
        // state.selectedInvoiceId = action.payload || '';
        // }
    },
    extraReducers: (builder) => {
        builder
            // Fetch Invoices
            .addCase(fetchEstimates.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchEstimates.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.estimates = action?.payload.estimates || [];
                state.errorMessage = '';
            })

            .addCase(fetchEstimates.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Fetch Estimate by ID
            .addCase(fetchEstimateById.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(fetchEstimateById.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.estimateDetails = action.payload || [];
                state.errorMessage = '';
            })
            .addCase(fetchEstimateById.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message
            })

            // Add Estimate
            .addCase(addEstimate.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(addEstimate.fulfilled, (state, action: any) => {
                state.status = ApiStatus.SUCCESS;
                state.isEstimateCreated = true;
                state.estimates.push(action.payload);
                state.errorMessage = '';

                toast.success(action.payload.message);
            })
            .addCase(addEstimate.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.isEstimateCreated = false;
                state.errorMessage = action.error.message
            })

            // Delete Estimate
            .addCase(deleteEstimate.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(deleteEstimate.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';

                const { id, message } = action.payload;
                state.estimates = state.estimates.filter(item => item._id !== id)

                toast.success(message);
            })
            .addCase(deleteEstimate.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                state.errorMessage = action.error.message

                toast.success(state.errorMessage);
            })

            // Update Estimate
            .addCase(updateEstimate.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(updateEstimate.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                const { message, estimate: updateEstimate } = action.payload
                state.estimates = state.estimates
                    .map(item => (item._id === item._id ? { ...item, ...updateEstimate } : item));

                state.errorMessage = '';

                toast.success(message);
            })
            .addCase(updateEstimate.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
            })

            // Dispatch Sale
            .addCase(dispatchSale.pending, (state, action) => {
                state.status = ApiStatus.LOADING;
            })
            .addCase(dispatchSale.fulfilled, (state, action) => {
                state.status = ApiStatus.SUCCESS;
                state.errorMessage = '';
                const { message } = action.payload;
                toast.success(message);
            })
            .addCase(dispatchSale.rejected, (state, action) => {
                state.status = ApiStatus.FAILED;
                // state.errorMessage = action.error.message
                // toast.error(state.errorMessage);
            })

            // .addCase(manualPayment.pending, (state, action) => {
            //     state.status = ApiStatus.LOADING;
            // })
            // .addCase(manualPayment.fulfilled, (state, action) => {
            //     state.status = ApiStatus.SUCCESS;
            //     state.errorMessage = '';
            //     const { message } = action.payload;
            //     toast.success(message);
            // })
            // .addCase(manualPayment.rejected, (state, action) => {
            //     state.status = ApiStatus.FAILED;
            //     state.errorMessage = action.error.message
            //     toast.success(state.errorMessage);
            // })
            // //  Share Invoice Payment Receipt
            // .addCase(shareInvoicePaymentReceipt.pending, (state, action) => {
            //     state.status = ApiStatus.LOADING;
            // })
            // .addCase(shareInvoicePaymentReceipt.fulfilled, (state, action) => {
            //     state.status = ApiStatus.SUCCESS;
            //     state.errorMessage = '';
            //     const { message } = action.payload;
            //     toast.success(message);
            // })
            // .addCase(shareInvoicePaymentReceipt.rejected, (state, action) => {
            //     state.status = ApiStatus.FAILED;
            //     state.errorMessage = action.error.message
            //     toast.error(state.errorMessage);
            // })
            // // Fetch invoice without saving to state
            // .addCase(fetchInvoicesWithoutState.pending, (state, action) => {
            //     state.status = ApiStatus.LOADING;
            // })
            // .addCase(fetchInvoicesWithoutState.fulfilled, (state, action: any) => {
            //     state.status = ApiStatus.SUCCESS;
            //     state.errorMessage = '';
            //     const { message } = action.payload;
            //     toast.success(message);
            // })
            // .addCase(fetchInvoicesWithoutState.rejected, (state, action) => {
            //     state.status = ApiStatus.FAILED;
            //     state.errorMessage = action.error.message
            //     toast.error(state.errorMessage);
            // })

            
    }
});

export default estimateSlice.reducer;
